import { useMutation, useQueryClient } from "@tanstack/react-query";
import { convertInvoiceCurrency } from "../../api/apiInvoices";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

export const useConvertInvoiceCurrency = () => {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const lang = i18n.language;

    const { mutate: convertInvoiceCurrencyMutate, isPending } = useMutation({
        mutationFn: ({ invoiceId, currencyId }) => convertInvoiceCurrency(invoiceId, currencyId),
        onSuccess: (data, variables) => {
            toast.success(lang === "ar" ? "تم تحويل عملة الفاتورة بنجاح" : "Invoice currency converted successfully");
            // Invalidate queries to refetch the invoice with new converted amounts
            queryClient.invalidateQueries(["programInvoice"]);
            queryClient.invalidateQueries(["invoices"]);
        },
        onError: (error) => {
            const errorMessage =
                error.response?.data?.message ||
                (lang === "ar" ? "حدث خطأ أثناء تحويل عملة الفاتورة" : "An error occurred while converting the invoice currency");
            toast.error(errorMessage);
        },
    });

    return { convertInvoiceCurrencyMutate, isPending };
};

export default useConvertInvoiceCurrency;
